import { useLocation, useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';


const Return_policy = ({ companyDetail }) => {


    const navigate = useNavigate();
    const location = useLocation();
    const [returnPolicy, setReturnPolicy] = useState("")

    useEffect(() => {
        if (location.state) {
            setReturnPolicy(location.state.returnPolicy)
        }
    }, [location.state]);
    return (
        <>
            {/* Breadcrumb Section Start */}
            <section className="breadscrumb-section pt-0">
                <div className="container-fluid-lg">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadscrumb-contain">
                                <h2>Returns & Refunds </h2>
                                <nav>
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item">
                                            <a href="index-2.html">
                                                <i className="fa-solid fa-house" />
                                            </a>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Returns & Refunds
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Breadcrumb Section End */}
            {/* 404 Section Start */}
            <section className="section-404 section-lg-space">
                <div className="container-fluid-lg">
                    <div className="row">

                        <div className="col-12 bg-white p-3">
                        <div dangerouslySetInnerHTML={{ __html: companyDetail.company_return }} className='editor inter-font'></div>

                            {/* <div>
                                <h4 className='fw-bold inter-font mb-2'>
                                    Q1. Can I return or exchange my perfume?</h4>
                                <h4>
                                    Due to the personal and hygienic nature of fragrance products, we do not accept returns or exchanges unless:
                                </h4>


                                <ul className="list-style-disc ps-4 mt-2">
                                    <li> <h4>* The product received is damaged</h4></li><br />
                                    <li><h4>* The product received is defective or incorrect</h4></li>
                                </ul>

                                <h4 className='mt-2'>
                                    In such cases, please contact us at support@valorelle.in within 48 hours of delivery, along with clear photos of the product and packaging.
                                </h4>
                                <h4 className='fw-bold inter-font mt-5  mb-2'>
                                    Q2. How do refunds work for damaged/defective orders?
                                </h4>
                                <h4>Once our team verifies the issue, a refund will be processed to your original payment method within 5–7 business days, or a replacement may be arranged depending on stock availability.
                                </h4>



                                <button
                                    onClick={() => navigate("/")}
                                    className="btn btn-md text-white theme-bg-color mt-4 mx-auto"
                                >
                                    Back To Home
                                </button>
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>
            {/* 404 Section End */}
        </>
    )
}

export default Return_policy;